import { CUSTOMER_FEATURE_SETTINGS } from 'src/routes/Customers/modules/types';

export const CUSTOMER_ACCESS_INITIAL_VALUES = {
  customerId: '',
  ipAddresses: [],
  throughput: '',
  enabled: false,
};

export const CUSTOMER_FEATURE_SETTINGS_INITIAL_VALUES = {
  customerId: '',
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_WAKE]: undefined,
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_REM]: undefined,
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_APNEA]: undefined,
};

export const CUSTOMER_INITIAL_VALUES = {
  name: '',
  contactId: '',
  address: '',
  contactName: '',
  contactEmail: '',
  regionalAccess: [],
};
